import React, { useEffect, useRef, useState } from "react";
import HeaderDropdown from "./HeaderDropdown/HeaderDropdown";
import {
  useGetTotalPointsQuery,
  useGetWalletQuery,
  useMyProfileQuery,
  useGetNotificationsQuery,
} from "../../services/userApi";
import { useNavigate, useLocation } from "react-router-dom";
import {resizeCloudinaryUrl} from '../../utils/cloudinarylink_replace.js'
import { useClickOutside } from "./../../hooks/useClickOutside";
import { IoMdNotifications } from "react-icons/io";
import { IoGiftOutline, IoMoonOutline, IoSunnyOutline } from "react-icons/io5";
import "./Header.css";
import { io } from "socket.io-client";
import { env } from "../../env";
import { jwtDecode } from "jwt-decode";
import { getLocalStorage } from "./../../utils/function/localStorage";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { useSelector, useDispatch } from "react-redux";
import { setUserProfile } from "../../store/Slices/userProfileSlice";
import { useHeader } from "../../context/HeaderContext.js";
import { useTheme } from "../../context/ThemeContext";

const Header = () => {
  const [tokenAvailable, setTokenAvailable] = useState(false);
  const [notificationList, setNotificationList] = useState([]);
  const [profileImageError, setProfileImageError] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const bellIconRef = useRef(null);
  const profileRef = useRef(null);

  const dispatch = useDispatch();
  const { screenName, registerRefetch } = useHeader();
  const navigate = useNavigate();
  const location = useLocation();

  const isHomePage =
    location.pathname === "/home" ||
    location.pathname === "/home/" ||
    location.pathname === "/" ||
    location.pathname === "" ||
    screenName === "Home";
  const displayScreenName = isHomePage ? "Home" : screenName;

  const isGiftShow = true;
  const showFirstButton = true;

  useEffect(() => {
    const interval = setInterval(() => {
      const token = localStorage.getItem("tp_Aa_uth_access");
      if (token) {
        setTokenAvailable(true);
        clearInterval(interval);
      }
    }, 200);
    return () => clearInterval(interval);
  }, []);

  const { data: profileData, refetch: refetchGetMyProfile } = useMyProfileQuery(
    undefined,
    { skip: !tokenAvailable }
  );

  const { data: profile } = useMyProfileQuery(undefined, {
    skip: !tokenAvailable,
  });
  const { data: notifications, refetch: refetchNotifications } =
    useGetNotificationsQuery({ type: "bell icon" }, { skip: !tokenAvailable });
  const { data: getTotalPoints, refetch: refetchTotalPoints } =
    useGetTotalPointsQuery(undefined, { skip: !tokenAvailable });
  const { data: getWallet, refetch: refetchWallet } = useGetWalletQuery(
    undefined,
    { skip: !tokenAvailable }
  );

  useEffect(() => {
    dispatch(setUserProfile({ country: profileData?.data?.[0]?.country }));
  }, [profileData?.data]);

  const { country } = useSelector((state) => state.userProfile);
  const { isDarkMode, toggleTheme } = useTheme();

  useClickOutside(profileRef, () => setOpenMenu(false));

  const token = getLocalStorage("tp_Aa_uth_access");
  let decodedUsername = null;
  if (token) {
    const decodedToken = jwtDecode(token);
    decodedUsername = decodedToken.username;
  }

  const socket = io(env.BASE_URL, {
    transports: ["websocket"],
  });

  useEffect(() => {
    setNotificationList(notifications?.data);
  }, [notifications]);

  useEffect(() => {
    if (!tokenAvailable) return;
    socket.on("newNotification", (notification) => {
      if (notification.username === decodedUsername) {
        setNotificationList((prev) => [...prev, notification]);
      }
    });
    return () => socket.disconnect();
  }, [socket, decodedUsername, tokenAvailable]);

  useEffect(() => {
    if (!tokenAvailable) return;
    refetchNotifications();
    refetchWallet();
    refetchTotalPoints();
  }, [tokenAvailable, refetchNotifications, refetchWallet, refetchTotalPoints]);

  useEffect(() => {
    if (!tokenAvailable) return;
    registerRefetch(() => {
      refetchNotifications();
      refetchWallet();
      refetchTotalPoints();
      refetchGetMyProfile();
    });
  }, [
    tokenAvailable,
    registerRefetch,
    refetchNotifications,
    refetchWallet,
    refetchTotalPoints,
    refetchGetMyProfile,
  ]);

  if (!tokenAvailable || !displayScreenName) return null;

  return (
    <div className="header-wrapper" style={{ background: isDarkMode ? '#1e1e1e' : '#fff', borderBottomColor: isDarkMode ? 'rgba(255,255,255,0.1)' : '#ebebeb' }}>
      <div className="header-container">
      <div className="header-main-view">
        <div className="header-title-wrap">
          <h2 className="main-header-title" style={{ color: isDarkMode ? '#fff' : '#000' }}>
            {displayScreenName?.length > 13
              ? `${displayScreenName?.slice(0, 11)}...`
              : displayScreenName}
          </h2>
        </div>
        <div className="header-actions">
          <button
            className="points-button"
            onClick={() => navigate("/home/all-point-history")}
            style={{
              backgroundColor: isDarkMode ? 'transparent' : '#fff',
              border: `1.5px solid ${isDarkMode ? 'rgba(255,255,255,0.2)' : '#e0e0e0'}`
            }}
          >
            <span className="points-text">
              {(getTotalPoints?.currentPoint || 0)
                .toFixed(2)
                .replace(/\.?0+$/, "")}
            </span>
            <img
              src="https://i.postimg.cc/1zKkRz5N/point.png"
              alt="points"
              className="points-icon"
            />
          </button>

          <button
            className="wallet-button"
            onClick={() => navigate("/home/wallet")}
            style={{
              backgroundColor: isDarkMode ? 'transparent' : '#e8f5e9',
              border: `1.5px solid ${isDarkMode ? 'rgba(76,175,80,0.5)' : '#c8e6c9'}`,
              color: isDarkMode ? '#4caf50' : '#2e7d32'
            }}
          >
            {country === "India"
              ? `₹${getWallet?.data?.current_balance?.toFixed(2)}`
              : country === "Nigeria"
              ? `₦${(getWallet?.data?.current_balance * 16)?.toFixed(2)}`
              : `$${(getWallet?.data?.current_balance / 100).toFixed(4)}`}
          </button>

          {displayScreenName === "Home" && isGiftShow && (
            <button
              className="gift-button"
              onClick={() => navigate("/home/referral")}
              style={{
                backgroundColor: isDarkMode ? 'transparent' : '#fff',
                border: `1.5px solid ${isDarkMode ? 'rgba(255,255,255,0.2)' : '#e0e0e0'}`
              }}
            >
              {showFirstButton ? (
                <div className="gift-button-content" style={{ color: isDarkMode ? '#aaa' : '#555' }}>
                  <IoGiftOutline size={17} />
                </div>
              ) : (
                <span className="gift-button-text">₹1000</span>
              )}
            </button>
          )}

          <button
            className="theme-toggle-button"
            onClick={toggleTheme}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginLeft: '10px',
              marginRight: '10px'
            }}
          >
            {isDarkMode ? (
              <IoSunnyOutline size={22} color="#FFD700" />
            ) : (
              <IoMoonOutline size={22} color="#1877f2" />
            )}
          </button>

          <div ref={profileRef} style={{ position: "relative" }}>
            <div className="header-profile-progress">
              <CircularProgressbar
                value={(() => {
                  const items = [
                    { id: "register", completed: true },
                    {
                      id: "email",
                      completed: profile?.data?.[0]?.isEmailVerified,
                    },
                    ...(profile?.data?.[0]?.country === "India"
                      ? [
                          {
                            id: "mobile",
                            completed: profile?.data?.[0]?.isMobileVerified,
                          },
                        ]
                      : []),
                    {
                      id: "profile_image",
                      completed: profile?.data?.[0]?.profile_image_status,
                    },
                    {
                      id: "gender",
                      completed: Boolean(profile?.data?.[0]?.gender),
                    },
                    { id: "dob", completed: Boolean(profile?.data?.[0]?.dob) },
                    {
                      id: "address",
                      completed: Boolean(profile?.data?.[0]?.address),
                    },
                    {
                      id: "country",
                      completed: profile?.data?.[0]?.hasOwnProperty("country"),
                    },
                    {
                      id: "whatsapp",
                      completed: Boolean(profile?.data?.[0]?.whatsapp),
                    },
                    { id: "kyc", completed: profile?.data?.[0]?.isKYCVerified },
                  ];
                  const count = items.filter((item) => item.completed).length;
                  return (count / items.length) * 100;
                })()}
                strokeWidth={5}
                styles={buildStyles({
                  pathColor: "#4CAF50",
                  trailColor: "#E0E0E0",
                  strokeLinecap: "round",
                })}
              />
              <button
                className="profile-button"
                onClick={() => setOpenMenu(!openMenu)}
              >
                <img
                  src={
                    profile?.data?.[0]?.profile_pic && !profileImageError
                      ? resizeCloudinaryUrl(profile?.data?.[0]?.profile_pic,250,250)
                      : profile?.data?.[0]?.gender === "Male"
                      ? resizeCloudinaryUrl("https://res.cloudinary.com/dztzqhifb/image/upload/f_auto,q_auto/v1768044999/tasks/sjosv5x2tpjpiyn4we00.webp",250,250)
                      : profile?.data?.[0]?.gender === "Female"
                      ? resizeCloudinaryUrl("https://res.cloudinary.com/dztzqhifb/image/upload/f_auto,q_auto/v1768045147/tasks/v8tmxdrti1cdj5vsl5eo.webp",250,250)
                      : resizeCloudinaryUrl("http://res.cloudinary.com/dztzqhifb/image/upload/f_auto,q_auto/v1764826730/tasks/xqwdpavdn9pce1xyn08z.png",250,250)
                  }
                  alt="profile"
                  className="avatar"
                  onError={() => setProfileImageError(true)}
                />
              </button>
              <div className="header-progress-tooltip">
                {(() => {
                  const items = [
                    { id: "register", completed: true },
                    {
                      id: "email",
                      completed: profile?.data?.[0]?.isEmailVerified,
                    },
                    ...(profile?.data?.[0]?.country === "India"
                      ? [
                          {
                            id: "mobile",
                            completed: profile?.data?.[0]?.isMobileVerified,
                          },
                        ]
                      : []),
                    {
                      id: "profile_image",
                      completed: profile?.data?.[0]?.profile_image_status,
                    },
                    {
                      id: "gender",
                      completed: Boolean(profile?.data?.[0]?.gender),
                    },
                    { id: "dob", completed: Boolean(profile?.data?.[0]?.dob) },
                    {
                      id: "address",
                      completed: Boolean(profile?.data?.[0]?.address),
                    },
                    {
                      id: "country",
                      completed: profile?.data?.[0]?.hasOwnProperty("country"),
                    },
                    {
                      id: "whatsapp",
                      completed: Boolean(profile?.data?.[0]?.whatsapp),
                    },
                    { id: "kyc", completed: profile?.data?.[0]?.isKYCVerified },
                  ];
                  const count = items.filter((item) => item.completed).length;
                  const percent = (count / items.length) * 100;
                  return `${Math.round(percent)}%`;
                })()}
              </div>
            </div>
            {openMenu && (
              <HeaderDropdown
                visible={openMenu}
                setVisible={setOpenMenu}
                navigation={navigate}
              />
            )}
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default Header;
